import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdOpsCodeContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type { AysCodeResponse } from '@bindoc-projects/code-domain-lib';
import { AysCode } from '@bindoc-projects/code-domain-lib';

export const FilterConditionOpsCodeThreeDigitsPluginType: FilterConditionPluginSpecification<
  AysCode[],
  JsonObj,
  BdOpsCodeContentCondition
> = {
  type: 'threeDigitOpsCode',
  category: 'case',
  displayName: { de: 'OPS-Ziffer 3-Steller' },
  sortingIndex: 10,
  occurrence: 'single',
  fromObject(obj: JsonObj): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionOpsCodeThreeDigitsPlugin(
        obj.codes.map((it) => AysCode.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdOpsCodeContentCondition,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionOpsCodeThreeDigitsPlugin(
        (jsonObj.includes ?? []).map((it) => AysCode.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionOpsCodeThreeDigitsPlugin([]);
  },
};

export class FilterConditionOpsCodeThreeDigitsPlugin extends FilterConditionPluginImpl<
  AysCode[],
  JsonObj
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCode[],
    JsonObj,
    BdOpsCodeContentCondition
  > = FilterConditionOpsCodeThreeDigitsPluginType;

  constructor(private codes: AysCode[]) {
    super(FilterConditionOpsCodeThreeDigitsPluginType.type);
  }

  clone(): FilterConditionOpsCodeThreeDigitsPlugin {
    return new FilterConditionOpsCodeThreeDigitsPlugin([
      ...this.codes.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionOpsCodeThreeDigitsPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.codes,
        other.codes,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.codes.length === 0) {
      return 'Mindestens eine OPS-Ziffer auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdOpsCodeContentCondition(this.codes, []);
  }

  toJSON(): JsonObj | null {
    return {
      type: this.type,
      codes: this.codes,
    };
  }

  toText(): string | null {
    return 'OPS-Ziffer 3-Steller';
  }

  toValue(): AysCode[] {
    return this.codes;
  }
}

interface JsonObj {
  type: string;
  codes: AysCodeResponse[];
}
